"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideThemeColors = exports.getMostReadable = exports.getMostVisible = exports.getTinyColor = void 0;
var tinycolor_1 = require("@ctrl/tinycolor");
var constants_1 = require("./constants");
var getTinyColor = function (color) {
    return typeof color === "string" ? new tinycolor_1.TinyColor(color) : constants_1.UIColors.dark;
};
exports.getTinyColor = getTinyColor;
var rgb2lab = function (RGBInput) {
    var rgb = [0, 0, 0], xyz = [0, 0, 0], Lab = [0, 0, 0];
    for (var i = 0; i < RGBInput.length; i++) {
        var value = RGBInput[i] / 255;
        if (value > 0.04045) {
            value = Math.pow((value + 0.055) / 1.055, 2.4);
        }
        else {
            value = value / 12.92;
        }
        rgb[i] = value * 100;
    }
    xyz[0] = (rgb[0] * 0.4124 + rgb[1] * 0.3576 + rgb[2] * 0.1805) / 95.047; // ref_X =  95.047   Observer= 2°, Illuminant= D65
    xyz[1] = (rgb[0] * 0.2126 + rgb[1] * 0.7152 + rgb[2] * 0.0722) / 100.0; // ref_Y = 100.000
    xyz[2] = (rgb[0] * 0.0193 + rgb[1] * 0.1192 + rgb[2] * 0.9505) / 108.883; // ref_Z = 108.883
    for (var i = 0; i < 3; i++) {
        var value = xyz[i];
        if (value > 0.008856) {
            value = Math.pow(value, 1 / 3);
        }
        else {
            value = 7.787 * value + 16 / 116;
        }
        xyz[i] = value;
    }
    Lab[0] = parseFloat((116 * xyz[1] - 16).toFixed(3));
    Lab[1] = parseFloat((500 * (xyz[0] - xyz[1])).toFixed(3));
    Lab[2] = parseFloat((200 * (xyz[1] - xyz[2])).toFixed(3));
    return Lab;
};
var getColorDistance = function (color1, color2) {
    var color1RGB = (0, exports.getTinyColor)(color1).toRgb();
    var color2RGB = (0, exports.getTinyColor)(color2).toRgb();
    var color1LAB = rgb2lab([color1RGB.r, color1RGB.g, color1RGB.b]);
    var color2LAB = rgb2lab([color2RGB.r, color2RGB.g, color2RGB.b]);
    return Math.sqrt(Math.pow(color1LAB[0] - color2LAB[0], 2) +
        Math.pow(color1LAB[1] - color2LAB[1], 2) +
        Math.pow(color1LAB[2] - color2LAB[2], 2));
};
var getMostVisible = function (baseColor, colors, WCAG2FallbackParms, readableColorsFallback, colorDistanceThreshold) {
    if (WCAG2FallbackParms === void 0) { WCAG2FallbackParms = {
        level: "AA",
        size: "large",
    }; }
    if (typeof baseColor !== "string") {
        return constants_1.UIColors.dark;
    }
    var visibleColor = colors.find(function (color) {
        return (typeof color === "string"
            ? getColorDistance(baseColor, color)
            : constants_1.UIColors.dark) >=
            (colorDistanceThreshold || constants_1.COLOR_DISTANCE_THRESHOLD);
    });
    return visibleColor
        ? (0, exports.getTinyColor)(visibleColor)
        : (0, exports.getMostReadable)(baseColor, readableColorsFallback, WCAG2FallbackParms);
};
exports.getMostVisible = getMostVisible;
var getMostReadable = function (baseColor, colorList, WCAG2FallbackParms) {
    if (typeof baseColor !== "string") {
        return constants_1.UIColors.dark;
    }
    var _colorList = [];
    colorList === null || colorList === void 0 ? void 0 : colorList.forEach(function (color) {
        if (typeof color === "string") {
            _colorList === null || _colorList === void 0 ? void 0 : _colorList.push(color);
        }
    });
    return ((0, tinycolor_1.mostReadable)(baseColor, (_colorList === null || _colorList === void 0 ? void 0 : _colorList.length) ? _colorList : [constants_1.UIColors.light, constants_1.UIColors.dark], __assign(__assign({}, WCAG2FallbackParms), { includeFallbackColors: true })) || constants_1.UIColors.dark);
};
exports.getMostReadable = getMostReadable;
var overrideThemeColors = function (theme, colors) {
    return __assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), colors) });
};
exports.overrideThemeColors = overrideThemeColors;
